<template>
    <conversation-list
        ref="list"
        v-bind="{filterList, delay}"
        @change="onChange"
        :add-to-group-props="addToGroupProps"
    ></conversation-list>
</template>

<script>
  import ConversationList from "../../components/conversations/index";
  import eventBus from "../../event-bus";

  export default {
    props: {
      filterList: Array,
      delay: {
        type: Number,
        default: 700,
      },
      addToGroupProps: Object,
    },

    methods: {
      /**
       * @param {Object} conversation
       */
      onChange(conversation) {
        if (conversation) {
          eventBus.$emit('conversation-list-change', conversation);
        }
      },

      /**
       * @param {Object} message
       * @return {undefined}
       */
      refreshList(message) {
        this.$refs.list.refreshList();
      },

      /**
       * @param {number} brandId
       * @param {number} contactId
       * @param {Object|null} model
       */
      onContactNoteStored({brandId, contactId, model}) {
        this.$refs.list.contactNoteStored({brandId, contactId, model});
      },

      /**
       * @param {Number} conversationId
       * @param {Object} model
       */
      onContactStored({conversationId, model}) {
        this.$refs.list.onContactStored({conversationId, model});
      },

      /**
       * @param conversationId
       * @param items
       */
      onScheduleListChanged({conversationId, list = null}) {
        this.$refs.list.scheduleListChanged({conversationId, list});
      },
    },

    created() {
      eventBus.$on('quick-message-sent', this.refreshList);
      eventBus.$on('contact-note-stored', this.onContactNoteStored);
      eventBus.$on('contact-stored', this.onContactStored);
      eventBus.$on('schedule-list-changed', this.onScheduleListChanged);
    },

    beforeDestroy() {
      eventBus.$off('quick-message-sent', this.refreshList);
      eventBus.$off('contact-note-stored', this.onContactNoteStored);
      eventBus.$off('contact-stored', this.onContactStored);
      eventBus.$off('schedule-list-changed', this.onScheduleListChanged);
    },

    components: {
      ConversationList,
    },
  }
</script>
